<template>
    <div>
        <b-modal
            v-model="modalShow"
            :title="$t('POLICY.POPUP.TITLE.ADD_RULE')"
            @ok="okFunction"
            @hide="callOnHide"
            :ok-disabled="isDisableOK"
            ok-only
        >
            <b-container>
                <AddingRuleForm
                    ref="addingRuleForm"
                    :rawRule="rule"
                    :newTmplt="newTmplt"
                    :categoryList="categoryList"
                    :templateList="templateList"
                    :actionTemplateList="actionTemplateList"
                    :callSetActionList="callSetActionList"
                    :curLang="curLang"
                    :callChangeFormValidStat="changeFormValidStat"
                    :formType="formType"
                    :userList="userList"
                    :alertOptions="alertOptions"
                    :roleCode="roleCode"
                />
            </b-container>
        </b-modal>
    </div>
</template>

<script>
import {BModal, BContainer} from "bootstrap-vue";
import AddingRuleForm from "./AddingRuleForm.vue";
import "bootstrap-vue/dist/bootstrap-vue.css"
import _ from "lodash";
export default {
    name: "AddRuleModal",
    components: {BModal, BContainer, AddingRuleForm},
    data() {
        return {
            formType: 0,       //NEW: 0, EDIT: 1, COPY: 2
            isAutoAssessment: true,
            isDisableOK: true,
            modalShow: false,
        }
    },
    props: {
        roleCode: String,
        popUpTitle: {
            type: String,
            default: "Add Rule"
        },
        actionTemplateList: Array,  // action 정보 리스트
        rule: Object,               // Popup 에서 control 될 Rule 정보
        newTmplt: Array,            // 사용되고있는 Template의 정보 리스트
        categoryList: Array,        // 회사에 등록되어있는 Category Label 정보 리스트
        userList: Array,            // 회사에 가입되어있는 사용자 리스트 정보(Email 수신자 추가시 필요)
        alertOptions: Array,
        callLoading: Function,
        callSaveRule: Function,
        callSetActionList: Function,
        callGetAlertOption: Function,
        callOnHide: {
            type: Function,
            default: ()=>{}
        }
    },
    computed: {
        templateList() {
            let rawTemplates = _.cloneDeep(this.$store.state.templateList);
            let vndrTemplates = [];
            vndrTemplates = _.forEach(rawTemplates, (template) => {
                const vendor = template.vendor.toLowerCase();
                template.prod = `${vendor}_${template.prod}`;
            });
            return vndrTemplates;
        },
        curLang: function () {
            return this.$i18n.locale;
        },
    },
    methods: {
        checkLastCondition(ruleDetail) {
            if(_.last(ruleDetail.cndVal).tmpltId == "new") {
                const validCnds = ruleDetail.cndVal.slice(0,-1);
                ruleDetail.cndVal = validCnds;
            }
            return ruleDetail;
        },
        changeFormValidStat(isValid) {
            this.isDisableOK = !isValid;
        },
        showPopup(FORM_TYPE) {
            this.formType = FORM_TYPE;
            if (FORM_TYPE === 0) {
                this.isDisableOK = true;
            }
            this.modalShow = true;
        },
        okFunction() {
            const rule = this.$refs['addingRuleForm'].getRuleInfo();
            let ruleDetail = this.checkLastCondition(rule.ruleDetail);
            if (rule.radioButtons === 'auto') {
                ruleDetail.autoExeYn = 'Y';
            } else {
                ruleDetail.autoExeYn = 'N';
                ruleDetail.cndVal = [];
            }
            this.callLoading(true);
            this.callSaveRule(ruleDetail);
            this.$refs.addingRuleForm.reRender();
        },
    }
}
</script>

<style scoped lang="scss">
/deep/ .modal-header {
    height: 48px;
    padding: 0;
}

/deep/ .modal-header .close {
    position: absolute;
    right: 12px;
    font-size: 16px;
    padding: 4px;
    text-align: center;
    margin: 10px 0;
    color: #7e8793;
}

/deep/ .modal-title {
    width: 100%;
    text-align: center;
    height: 26px;
    font-family: 'Noto Sans Korean', serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.63;
    padding: 11px;
    color: var(--darkgray-1);
}

/deep/ .container {
    padding: 0
}

/deep/ .modal-footer button {
    margin-right: 16px;
    border-radius: 4px !important;
    width: 61px;
}

/deep/ .modal-footer {
    height: 72px;
    padding: 0;
}
/deep/ .modal-footer button.btn.btn-primary.disabled {
    color: #fff !important;
    background-color: #71b6ffc2 !important;
    border-color: #71b6ffc2 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/policy/policyComponents/AddRuleModal.vue